import { createContext, useContext } from "react";
import { useSelector } from "react-redux";
import { LanguageEnum } from "jadro-pico/enums/common/LanguageEnum.ts";
import type { AppCoreState } from "../../Redux/AppCoreReducer.ts";
import { CommonErrorResources } from "./CommonErrorResources.ts";
import type { ErrorResources } from "./ErrorResources.ts";

export interface ErrorResourcesContextValue {
  primary: ErrorResources;
}

export const ErrorResourcesContext = createContext<ErrorResourcesContextValue | null>(null);

export function useErrorMessage(code: string): string {
  const ctx = useContext(ErrorResourcesContext);
  const lang = useSelector(
    (state: { core: AppCoreState }) => state.core.language ?? LanguageEnum.CS,
  );
  if (!ctx) throw new Error("useErrorMessage must be used within ErrorResourcesContext.Provider");
  return ctx.primary[lang]?.[code] ?? CommonErrorResources[lang]?.[code] ?? code;
}
